var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$eb.emit('BoxOpen')}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pulse"},[_c('i',{staticClass:"material-icons"},[_vm._v("voice_chat")])])
}]

export { render, staticRenderFns }